import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/pro-solid-svg-icons';
import * as React from 'react';

export const InfoIcon = ({ color = '' }) => {
  const styleObj: React.CSSProperties = !!color ? { color } : {};
  return <FontAwesomeIcon style={styleObj} icon={faInfo} size="sm" />;
};
